import { Outlet } from "react-router-dom";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import HeaderComponent from "../../components/header/HeaderComponent";
import SidebarMenuComponent from "../../components/header/SidebarMenuComponent";
import { useAuth } from "../../auth/AuthContext";
import { useState } from "react";

const Layout = () => {
  const theme = useTheme();
  const { isAuthenticated } = useAuth();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Header - Fixed at top */}
      <HeaderComponent 
        onMobileMenuToggle={handleMobileMenuToggle}
        isMobile={isMobile}
      />
      
      {/* Sidebar - Always visible */}
      <SidebarMenuComponent 
        mobileMenuOpen={mobileMenuOpen}
        onMobileMenuClose={handleMobileMenuClose}
      />
      
      {/* Main content area */}
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1,
          marginTop: { xs: '56px', sm: '72px' }, // Account for fixed header
          marginLeft: isAuthenticated && !isMobile ? '64px' : 0, // Account for collapsed sidebar when logged in on desktop
          minHeight: { xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 72px)' },
          backgroundColor: theme.palette.background.default,
          transition: theme.transitions.create(['margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          width: '100%',
          overflowX: 'hidden',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;
